module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgBXZDNDYJAEIVnNmY9agmWYAly82AIVqAegYNSgVjBmvBzlQ4kxhhvliAlUAJnMKwzRAi4h523+82+nRmEv6WWaialfLEWA7BQUwJXkjMEHEI5kRcKcwI5CjQ6GJuxAg1WC+zUzhsYmdFRgz6QLLTQawZ8P2JA0ecD1rhzbk7WuokW0P+Jc3fSfg2ihvrUKA3bYBUs+hB5C8zAFyDYvoAPGO7DzTr4SzhTwp5kXpal4T29HPs24SpMqI1NmzAYQjWquB22bEY4eNmM0FLTcT1+s/4CadtE2ck0MnsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Layout/images/menuleft.png
// module id = 1504
// module chunks = 0